<template>
  <div id='bd-code'>
    <el-form ref="form" label-width="100px" style="margin-top: 10px;">
      <el-form-item :label="styleTip">
        <el-radio-group v-model="codeStyle">
            <el-radio :label="1">{{ $t('window') }}</el-radio>
            <el-radio :label="2">{{ $t('embed') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="codeTip">
        <el-input type="textarea" :autosize="{ minRows: 12, maxRows: 20}" :value="styledCode"></el-input>
        <span v-if="codeStyle === 1">{{ $t('putSuperlink') }}</span>
        <span v-if="codeStyle === 2">{{ $t('putBeforeBody') }}</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleKefuChat">{{ $t('simulateChat') }}</el-button>
        <el-button class="copyBtn" type="primary" size="small" :data-clipboard-text="styledCode" @click="onCopy">{{ $t('copy') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Clipboard from 'clipboard'

export default {
  name: 'bd-code',
  data () {
    return {
      codeStyle: 1,
      // htmlTip: '复制代码，并放在网页</body>之前'
    }
  },
  computed: {
    ...mapGetters([ 'userInfo' ]),
    styleTip () {
      return this.$t('style')
    },
    codeTip () {
      return this.$t('code')
    },
    baseUrl () {
      return document.location.protocol + '//' + window.location.host + '/chat'
    },
    styledCode () {
      if (this.codeStyle === 1) {
        // 客服一对一对话: ' + this.object.workGroups[0].wid + '
        return '<a href="' + this.baseUrl + '?sub=' + this.userInfo.subDomain + '&uid=' + this.userInfo.adminUid +
          '&wid=&type=appointed&aid=' + this.userInfo.uid + '&ph=ph" target="_blank">' + this.$t('onlineChat') +  '</a>'
      } else {
        // 客服一对一对话
        return this.$t('codeBegin') + '\n' +
          '<div id="byteDesk"></div>\n' +
          '<script type="text/javascript">\n' +
          'window.adminUid = "' + this.userInfo.adminUid + '";\n' +
          'window.workGroupWid = "";\n' +
          'window.subDomain = "' + this.userInfo.subDomain + '";\n' +
          'window.type = "appointed";\n' +
          'window.agentUid = "' + this.userInfo.uid + '";\n' +
          '(function () {\n' +
          '  d = document;\n' +
          '  s = d.createElement("script");\n' +
          '  s.src = "https://cdn.bytedesk.com/js/float/narrow/index.js";\n' +
          '  s.async = 1;\n' +
          '  d.getElementsByTagName("head")[0].appendChild(s);\n' +
          '})();\n' +
          '<' +
          '/script>\n' +
          this.$t('codeEnd')
      }
    }
  },
  methods: {
    handleKefuChat () {
      // console.log('chat: ', record)
      let url = document.location.protocol + '//' + window.location.host + '/chat?sub=' + this.userInfo.subDomain +
        '&uid=' + this.userInfo.adminUid + '&wid=&type=appointed&aid=' + this.userInfo.uid + '&ph=ph'
      window.open(url)
    },
    onCopy () {
      console.log('submit!')
      var clipboard = new Clipboard('.copyBtn')
      clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.error('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    }
  }

}
</script>

<style scoped>
#bd-code {
  height: 100%;
  width: 500px;
  overflow: auto;
  text-align: left;
}
</style>
